import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  Button,
  CircularProgress,
  Container,
  IconButton,
} from '@mui/material';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import api from '../utils/api';
import AOS from 'aos';
import 'aos/dist/aos.css';

const DeletedSchools = () => {
  const navigate = useNavigate();
  const [deletedSchools, setDeletedSchools] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    AOS.init({ duration: 800, easing: 'ease-in-out', once: true });
  }, []);

  const fetchDeletedSchools = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await api.get('/api/schools/admin/deleted-schools');
      setDeletedSchools(response.data);
    } catch (error) {
      setError(error.response?.data?.message || 'Failed to load deleted schools');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDeletedSchools();
  }, []);

  const renderSchoolItem = (item) => (
    <Grid item xs={12} sm={6} md={4} key={item._id}>
      <Card
        sx={{
          boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
          borderRadius: 2,
          bgcolor: '#fff',
        }}
        data-aos="fade-up"
      >
        <CardContent>
          <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#2c3e50', mb: 1 }}>
            {item.schoolName}
          </Typography>
          <Typography variant="body2" sx={{ color: '#666', mb: 0.5 }}>
            Email: {item.email}
          </Typography>
          <Typography variant="body2" sx={{ color: '#666', mb: 0.5 }}>
            Location: {item.location}, {item.village}
          </Typography>
          <Typography variant="body2" sx={{ color: '#666', mb: 0.5 }}>
            Phone: {item.phoneNumber}
          </Typography>
          <Typography variant="body2" sx={{ color: '#666' }}>
            Deleted on: {new Date(item.deletedAt).toLocaleDateString()}
          </Typography>
        </CardContent>
      </Card>
    </Grid>
  );

  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          bgcolor: '#f8f9fa',
        }}
      >
        <CircularProgress size={60} sx={{ color: '#9C27B0' }} />
        <Typography variant="h6" sx={{ mt: 3, color: '#2c3e50' }}>
          Loading deleted schools...
        </Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          bgcolor: '#f8f9fa',
        }}
      >
        <Typography variant="h6" color="error" sx={{ mb: 3, textAlign: 'center' }}>
          {error}
        </Typography>
        <Button
          variant="contained"
          onClick={() => {
            setLoading(true);
            setError(null);
            fetchDeletedSchools();
          }}
          sx={{ bgcolor: '#9C27B0', '&:hover': { bgcolor: '#7B1FA2' }, px: 4, py: 1.5 }}
        >
          Try Again
        </Button>
      </Box>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ py: 4, bgcolor: '#f8f9fa', minHeight: '100vh' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 4 }} data-aos="fade-down">
        <IconButton onClick={() => navigate(-1)} sx={{ mr: 2 }}>
          <ArrowBackIcon sx={{ color: '#9C27B0' }} />
        </IconButton>
        <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#2c3e50' }}>
          Deleted Schools
        </Typography>
      </Box>
      {deletedSchools.length === 0 ? (
        <Typography sx={{ textAlign: 'center', color: '#666', mt: 5 }} data-aos="fade-up">
          No deleted schools found
        </Typography>
      ) : (
        <Grid container spacing={3} data-aos="fade-up">
          {deletedSchools.map((item) => renderSchoolItem(item))}
        </Grid>
      )}
    </Container>
  );
};

export default DeletedSchools;